class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      categoryTitle: ".bundle-builder__product-title .category-heading",
      categoryPrice: ".bundle-builder__product-title .category-price",
      productTypeButtons: ".bundle-builder__product-type-buttons",
      optionsContainer: "#bundle-options-container",
      sizeDropdown: "#select-size",
      colorSwatches: ".list-swatches",
      typeHeadings: ".bundle-builder__product-type .option-heading",
      typeSizeHeadings: ".bundle-builder__product-size h4",
      sizeContainer: ".bundle-builder__product-size",
      colorContainer: ".bundle-builder__product-color",
      selectedColor: ".bundle-builder__product-color .option-selected",
      quantitySelector: ".product-quantity",
    };

    if (window.innerWidth > 767) {
      document.querySelector("body").style.overflow = "hidden";
      const bundleBuilderHeight = window.innerHeight - this.getBoundingClientRect().top + "px";
      this.style.height = bundleBuilderHeight;
      this.querySelector(".bundle-builder__preview-sticky").style.height = bundleBuilderHeight;
    }

    this.selectedOptions = JSON.parse(
      this.querySelector("script#selected-options").innerHTML
    ).options;
    this.selected = {};

    this.reset();

    const params = new URLSearchParams(window.location.search);
    
    if (params.toString()) {
      for (const [key, value] of params.entries()) {
          const [index, optionKey] = key.split('_');
          if (this.selected[index]) {
              this.selected[index][optionKey] = value;
          } else {
              console.error('No entry found in this.selected for index:', index);
          }
      }
    }
  }

  connectedCallback() {
    checkPreorder();
    const promises = [loadAllProducts()];

    Promise.all(promises).then(() => {
      this.allColors = window.ALL_PRODUCTS.reduce((acc, product) => {
        acc[product.color] = {
          color_hex: product.color_hex,
          color_image_url: product.color_image_url
        };
        return acc;
      }, {});
  
      this.renderOptions();
      this.registerEventListeners();
      this.initDefaultSelection();
      this.initElement();

      if (window.innerWidth < 768) {
        this.bundleBuilderTabs();
      }
      
      Object.keys(this.selected).forEach((key) => {
        this.handleUpdate(key);
      });

      this.preloadImages();
      this.classList.add("loaded");
    });
  }

  preloadImages() {
    let imageSizeSuffix = '';
    const windowWidth = window.innerWidth;

    if (windowWidth < 480) {
      imageSizeSuffix = '_sm';
    } else if (windowWidth < 749) { 
      imageSizeSuffix = '_md';
    } else if (windowWidth < 1024) {
      imageSizeSuffix = '_lg';
    } else {
      imageSizeSuffix = '_xl';
    }

    // Get the variants for all the options
    const variantGroups = Object.keys(this.selected).map((key) => {
      const option = this.selected[key];
      return window.ALL_PRODUCTS.filter(
        (product) =>
          product.type === option.product_type
      ).map(v => {
        const optionConfig = this.selectedOptions[key];
        return {
          ...v,
          imageSrc: optionConfig.bundle_image ? optionConfig.bundle_image + imageSizeSuffix : 'bundle_image' + imageSizeSuffix
        }
      })
    });

    // Merge all the variants into one array
    const variants = variantGroups.reduce((acc, group) => {
      return acc.concat(group);
    }, []);
 
    // Create a new array of the img URLs
    let preloadImages = variants.map((variant) => {
      return variant[variant.imageSrc];
    });

    // Remove duplicates
    preloadImages = [...new Set(preloadImages)];

    preloadImages.filter(_ => _ != null).forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }

  renderOptions() {
    this.selectedOptions.forEach((option, index) => {
      this.renderOption(option.product_type, option.title, option.option_types, index);
    });
  }

  renderOption(productType, title, optionTypes, index) {
    const variants = window.ALL_PRODUCTS.filter((product) => product.type === productType);

    const groupedVariants = variants.reduce((acc, variant) => {
      const group = variant.bundle_type;
      if (group !== null) {
        if (!acc[group]) acc[group] = [];
        acc[group].push(variant);
      }
      return acc;
    }, {});

    const initialTemplate = document
      .getElementById("bundle-builder__category-template")
      .querySelector(".bundle-builder__form-category");
    const categoryEl = initialTemplate.cloneNode(true);

    const productTypeTitleMap = {
      "Bed Sheets": "Lagen",
      "Duvet Cover": "Dynebetræk",
      Pillowcase: "Pudebetræk",
    };

    categoryEl.setAttribute("data-option-index", index);
    categoryEl.setAttribute("data-product-type", productType);

    const fallbackTitle = productTypeTitleMap[productType] || productType;
    const titleEl = categoryEl.querySelector(this.selectors.categoryTitle);
    titleEl.textContent = title || fallbackTitle;

    const categoryPrice = categoryEl.querySelector(this.selectors.categoryPrice);
    categoryPrice.querySelector(".price").textContent = `Intet valgt`;

    const typeHeading = categoryEl.querySelector(this.selectors.typeHeadings);
    typeHeading.textContent = `${title} Type`;

    const optionTypesDiv = categoryEl.querySelector(this.selectors.productTypeButtons);
    optionTypesDiv.innerHTML = "";

    const optionTypesArray = optionTypes ? optionTypes.split(",") : Object.keys(groupedVariants);
    this.selected[index].available_types = optionTypesArray;

    if (optionTypesArray.length > 1) {
      optionTypesArray.forEach((optionType, index) => {
        const typeEl = document.createElement("div");
        typeEl.htmlFor = `${productType}-type${index + 1}`;
        typeEl.textContent = optionType;
        typeEl.setAttribute("data-type", optionType);
        optionTypesDiv.appendChild(typeEl);
      });

      optionTypesDiv.addEventListener("click", (evt) => {
        const selectedType = evt.target.getAttribute("data-type");
        const selectedTypeEl = evt.target;

        optionTypesDiv.querySelectorAll("div").forEach((typeEl) => {
          typeEl.classList.remove("selected");
        });

        selectedTypeEl.classList.add("selected");

        this.setSelectedOption(index, "type", selectedType);
        this.setSelectedOption(index, "size", null);
        this.setSelectedOption(index, "color", null);
      });
    } else {
      categoryEl.querySelector(".bundle-builder__product-type").style.display = "none";
      this.selected[index].type = optionTypesArray[0];
    }    

    const container = document.getElementById(this.selectors.optionsContainer.slice(1));
    container.appendChild(categoryEl);

    this.renderSizeOptions(index);
    this.renderColorOptions(index);
  }

  renderSizeOptions(optionIndex) {
    const selectedOption = this.selected[optionIndex];

    if (!selectedOption.type) {
      this.hideContainer(optionIndex, this.selectors.sizeContainer);
      return;
    } else {
      this.showContainer(optionIndex, this.selectors.sizeContainer);
    }

    const categoryEl = this.querySelector(
      `.bundle-builder__form-category[data-option-index="${optionIndex}"]`
    );

    const variants = window.ALL_PRODUCTS.filter(
      (product) =>
        product.type === selectedOption.product_type && product.bundle_type === selectedOption.type
    );

    const sortedVariants = variants.sort((a, b) => {
      const sizeA = a.size.split('x').map(Number);
      const sizeB = b.size.split('x').map(Number);
    
      for (let i = 0; i < sizeA.length; i++) {
        if (sizeA[i] !== sizeB[i]) {
          return sizeA[i] - sizeB[i];
        }
      }
    
      return 0; // Sizes are the same
    });

    const uniqueSizes = new Set();
    sortedVariants.forEach((product) => {
      if (product.size !== 0) {
        uniqueSizes.add(product.size);
      }
    });

    const sizeOptionsContainer = categoryEl.querySelector(".select-popout__list");
    sizeOptionsContainer.innerHTML = `
    <div class="select-popout__option-mobile-title">
    Vælg størrelse 
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 24 24"><path d="M6 12h6m6 0h-6m0 0V6m0 6v6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg>
  </div>
    `;

    document.querySelector(".select-popout__option-mobile-title .icon-plus").addEventListener("click", (evt) => {
      document.querySelector(".popout-list--visible").classList.remove("popout-list--visible");
      document.querySelector(".select-popout__toggle[aria-expanded='true']").setAttribute("aria-expanded", "false");
    });

    const span = categoryEl.querySelector(".select-popout__toggle span");
    if (span) {
      if (selectedOption.size) {
        span.textContent = selectedOption.size.includes('cm') ? selectedOption.size : `${selectedOption.size} cm`;
      } else {
        span.textContent = "Vælg størrelse";
      }
    }

    uniqueSizes.forEach((size) => {
      const sizeListItem = document.createElement("li");
      const sizeOptionDiv = document.createElement("div");
      const sizeLabelDiv = document.createElement("div");

      sizeListItem.className = "select-popout__item";
      sizeOptionDiv.className = "select-popout__option";
      sizeLabelDiv.className = "select-popout__option-label";

      sizeLabelDiv.textContent = size.includes('cm') ? size : `${size} cm`;

      sizeListItem.setAttribute("data-size", size);
      sizeOptionDiv.appendChild(sizeLabelDiv);
      sizeListItem.appendChild(sizeOptionDiv);

      sizeOptionsContainer.appendChild(sizeListItem);
    });

    document.querySelectorAll(".select-popout__item").forEach((option) => {
      option.addEventListener("click", this.handleSizeOptionClick.bind(this));
    });
  }

  renderColorOptions(optionIndex) {
    const selectedOption = this.selected[optionIndex];
  
    if (!selectedOption.size) {
      this.hideContainer(optionIndex, this.selectors.colorContainer);
      return;
    } else {
      this.showContainer(optionIndex, this.selectors.colorContainer);
    }
  
    const categoryEl = this.querySelector(
      `.bundle-builder__form-category[data-option-index="${optionIndex}"]`
    );
  
    const variants = window.ALL_PRODUCTS.filter(
      (product) =>
        product.type === selectedOption.product_type &&
        product.bundle_type === selectedOption.type &&
        product.size === selectedOption.size
    );
  
    const uniqueColors = new Set();
    variants.forEach((product) => {
      uniqueColors.add(product.color);
    });
  
    const colorSwatchesContainer = categoryEl.querySelector(this.selectors.colorSwatches);
    colorSwatchesContainer.innerHTML = "";
  
    uniqueColors.forEach((color) => {
      const variant = variants.find((product) =>
        product.type === selectedOption.product_type &&
        product.bundle_type === selectedOption.type &&
        product.size === selectedOption.size &&
        product.color === color
      );
  
      let isSoldout = variant.inStock === 0 && (variant.isPreorder !== "true" || variant.inventoryPolicy !== 'continue');
  
      const colorListItem = document.createElement("li");
      const colorAnchor = document.createElement("div");
      const colorDivWrapper = document.createElement("div");
  
      colorListItem.setAttribute("data-color", color);
      colorListItem.className = isSoldout ? "swatch-color swatch-soldout" : "swatch-color";
      colorAnchor.className = "swatch-btn swatch-btn--large motion-reduce";
      colorDivWrapper.className = "swatch-btn-wrapper";

      // if(variant.color == "Apricot") {
      //   console.log(variant);
      // }
  
      if (variant.color_hex === 'IMAGE' && variant.color_image_url) {
        const colorImg = document.createElement("img");
        colorImg.src = variant.color_image_url;
        colorDivWrapper.appendChild(colorImg);
        console.log('color image url', variant.color_image_url);
      } else {
        const colorSpan = document.createElement("span");
        colorSpan.style.backgroundColor = this.allColors[color].color_hex;
        colorDivWrapper.appendChild(colorSpan);
      }
  
      colorAnchor.appendChild(colorDivWrapper);
      colorListItem.appendChild(colorAnchor);
      colorSwatchesContainer.appendChild(colorListItem);
    });
  
    document.querySelectorAll(".swatch-color").forEach((swatch) => {
      swatch.addEventListener("click", this.handleColorSwatchClick.bind(this));
    });
  }
  
  hideContainer(optionIndex, selector) {
    const category = this.querySelector(
      `.bundle-builder__form-category[data-option-index="${optionIndex}"]`
    );
    const container = category.querySelector(selector);
    container.style.display = "none";
  }

  showContainer(optionIndex, selector) {
    const category = this.querySelector(
      `.bundle-builder__form-category[data-option-index="${optionIndex}"]`
    );
    const container = category.querySelector(selector);
    container.style.display = "block";
  }

  toggleBaseImages() {
    const fallbackImage = this.querySelector(".fallback-image");
    const startImage = this.querySelector(".start-image");
    let hasSheetVariant = false;
    let hasNonSheetVariants = false;

    Object.keys(this.selected).forEach((key) => {
      const option = this.selected[key];

      if (key == 0) {
        if (option.variant) {
          hasSheetVariant = true;
        }
      }

      if (key > 0) {
        if (option.variant) {
          hasNonSheetVariants = true;
        }
      }
    });

    const showFallbackImage = !hasSheetVariant && hasNonSheetVariants;

    if (showFallbackImage) {
      fallbackImage.style.display = "block";
    } else {
      fallbackImage.style.display = "none";
    }

    const showStartImage = !hasSheetVariant && !hasNonSheetVariants;

    if (showStartImage) {
      startImage.style.display = "block";
    } else {
      startImage.style.display = "none";
    }
  }

  reset() {
    this.selectedOptions.forEach((option, index) => {
      this.selected[index] = {
        product_type: option.product_type,
        type: null,
        color: null,
        size: null,
        quantity: option.default_quantity || 1
      };
    });
  }

  handleResetClick() {
    // Reset URL
    const url = window.location.origin + window.location.pathname;
    history.pushState(null, '', url);

    // Refresh site
    // window.location.reload();
    setTimeout(() => {
      window.location.reload();
    }, 500);
    // this.reset();
  }

  handleShareClick() {
    // Copy URL with queries to clipboard
    const url = window.location.href;
    navigator.clipboard.writeText(url);
    // Animate popup
    const popup = document.querySelector('.bundle-builder__share-popup');
    popup.style.display = 'block';
    popup.animate([
      // keyframes
      { opacity: 0, transform: "translate(-50%, 100%)" }, 
      { opacity: 1, transform: "translate(-50%, 0%)" }
    ], { 
      // timing options
      duration: 300,
      iterations: 1,
      fill: 'forwards',
      easing: 'ease-in-out'
    });
    popup.animate([
      // keyframes
      { opacity: 1, transform: "translate(-50%, 0%)" },
      { opacity: 0, transform: "translate(-50%, 100%)" } 
    ], { 
      // timing options
      delay: 1400,
      duration: 300,
      iterations: 1,
      fill: 'forwards',
      easing: 'ease-in-out'
    });
  }

  handleUpdate(optionIndex) {
    const optionConfig = this.selectedOptions[optionIndex];
    const selectedOption = this.selected[optionIndex];
    const categoryEl = this.querySelector(
      `.bundle-builder__form-category[data-option-index="${optionIndex}"]`
    );
    const variantsWithSize = window.ALL_PRODUCTS.filter(
      (product) =>
        product.type === selectedOption.product_type && product.size === selectedOption.size
    );
    const selectedVariant = variantsWithSize.find(
      (product) => product.color === selectedOption.color
    );

    this.renderSizeOptions(optionIndex);
    this.renderColorOptions(optionIndex);

    const priceWrapper = categoryEl.querySelector(this.selectors.categoryPrice);
    const previewImage = this.querySelector(`.selected-images img[data-index="${optionIndex}"]`);

    this.toggleBaseImages();

    if (selectedVariant) {
      priceWrapper.querySelector(".price").textContent = Shopify.formatMoney(selectedVariant.price);
      // priceWrapper.querySelector('.price-compare').textContent = Shopify.formatMoney(selectedVariant.price);
      // priceWrapper.querySelector('.price-compare').style.display = 'block';

      this.querySelector(".bundle-builder__preview-sticky .start-image").style.display = "none";
      previewImage.setAttribute(
        "src",
        selectedVariant[optionConfig.bundle_image || "bundle_image"]
      );

      let imageSizeSuffix = '';
      const windowWidth = window.innerWidth;

      if (windowWidth < 480) {
        imageSizeSuffix = '_sm';
      } else if (windowWidth < 749) { 
        imageSizeSuffix = '_md';
      } else if (windowWidth < 1024) {
        imageSizeSuffix = '_lg';
      } else {
        imageSizeSuffix = '_xl';
      }

      const imageSrc = optionConfig.bundle_image ? optionConfig.bundle_image + imageSizeSuffix : 'bundle_image' + imageSizeSuffix;
      previewImage.setAttribute("src", selectedVariant[imageSrc]);


      previewImage.style.display = "block";
      this.selected[optionIndex].variant = selectedVariant;
    } else {
      priceWrapper.querySelector(".price").textContent = `Intet valgt`;
      priceWrapper.querySelector(".price-compare").style.display = "none";

      previewImage.setAttribute("src", "");
      previewImage.style.display = "none";
      this.selected[optionIndex].variant = null;
      this.selected[optionIndex].color = null;
    }

    const selectedColor = categoryEl.querySelector(this.selectors.selectedColor);
    const quantitySelector = categoryEl.querySelector(this.selectors.quantitySelector);
    const quantityInput = quantitySelector.querySelector(".quantity__value");

    if (selectedOption.size) {
      quantitySelector.classList.remove("hidden");

      if (Number(quantityInput.innerText) == 0) {
        quantityInput.innerText = 1;
      }
      else if(selectedOption.quantity) {
        quantityInput.innerText = selectedOption.quantity;
      }
    } else {
      quantitySelector.classList.add("hidden");
    }

    if (selectedOption.color) {
      selectedColor.style.display = "block";
      selectedColor.textContent = selectedOption.color;
    } else {
      selectedColor.style.display = "none";
      selectedColor.textContent = "";
    }

    if (!selectedOption.type) {
      // Remove selected class from bundle-builder__product-type-buttons divs
      categoryEl.querySelectorAll(".bundle-builder__product-type-buttons div").forEach((div) => {
        div.classList.remove("selected");
      });
    } else {
      // Add selected class to the bundle-builder__product-type-buttons div
      const selectedTypeDiv = categoryEl.querySelector(`.bundle-builder__product-type-buttons div[data-type="${selectedOption.type}"]`);
      if(selectedTypeDiv) {
        selectedTypeDiv.classList.add('selected');
      }
    }

    this.updatePrices();
    this.updateURL();

    const tabCheckmark = this.querySelector(`.tab-button[data-index="${optionIndex}"] .tab-checkmark`);

    if (tabCheckmark) {
      if (selectedOption.variant) {
        tabCheckmark.style.display = "initial";  
      }
      else {
        tabCheckmark.style.display = "none";
      }
    }

    // Disable or enable the add-to-cart button based on whether all required options are selected (check required property on selectedOptions)
    // const addToCartButton = this.querySelector('.product__submit__add');

    // const allRequiredOptionsSelected = this.selectedOptions.filter(option => option.required).every(option => {
    //   const optionIndex = this.selectedOptions.indexOf(option);
    //   const selectedOption = this.selected[optionIndex];
    //   return selectedOption.variant !== null;
    // });

    // console.log(this.selectedOptions.filter(option => option.required))
    // console.log(allRequiredOptionsSelected)

    // if (allRequiredOptionsSelected) {
    //   addToCartButton.classList.remove('disabled');
    // }
    // else {
    //   addToCartButton.classList.add('disabled');
    // }
  }

  updateURL() {
    const params = new URLSearchParams();

    for (const [index, selectedOptions] of Object.entries(this.selected)) {
      for (const [optionKey, optionValue] of Object.entries(selectedOptions)) {
        if (['color', 'size', 'type', 'quantity'].includes(optionKey) && optionValue !== null) {
          const paramKey = `${index}_${optionKey}`;
          params.append(paramKey, optionValue);
        }
      }
    }

    const newURL = `${window.location.origin}${window.location.pathname}?${params.toString()}`;
    history.pushState(null, '', newURL);
  }

  updatePrices() {
    const totalPrices = [];
    const totalPricesWithDiscount = [];

    this.selectedOptions.forEach((option, index) => {
      let hasDiscount = false;
      let discountPercentage = 15;

      // Based on the discount depedency property, we check if the discount should be applied
      if (option.discount_dependency) {
        // The discount depedency is a comma separated list of indexes
        const discountDependency = option.discount_dependency.split(',').map(_ => Number(_));

        // If the discount dependency is fulfilled, we apply the discount
        if (discountDependency.every(discountIndex => {
          const match = this.selected[discountIndex - 1];
          if (!match) return false;

          // If variant property does not exist on match
          if (!match.variant) return false;

          return true;
        })) {
          hasDiscount = true;
          
          if (option.discount_percentage) {
            discountPercentage = Number(option.discount_percentage);
          }
        }
      }

      const categoryEl = this.querySelector(`.bundle-builder__form-category[data-option-index="${index}"]`);
      const priceWrapper = categoryEl.querySelector(this.selectors.categoryPrice);

      const selectedOption = this.selected[index];
      const selectedVariant = selectedOption.variant;

      if (selectedVariant) {
        if (hasDiscount) {
          const nowPrice = selectedVariant.price * (1 - (discountPercentage / 100));
          priceWrapper.querySelector('.price').textContent = Shopify.formatMoney(nowPrice);
          priceWrapper.querySelector('.price-compare').textContent = Shopify.formatMoney(selectedVariant.price);
          priceWrapper.querySelector('.price-compare').style.display = 'block';
          totalPrices.push(selectedVariant.price * selectedOption.quantity);
          totalPricesWithDiscount.push(nowPrice * selectedOption.quantity);

          // If the discount is applied, we set the discount percentage on the product
          selectedOption.discount_percentage = discountPercentage;
          selectedOption.discounted_price = nowPrice;
          selectedOption.normal_price = selectedVariant.price;
        }
        else {
          priceWrapper.querySelector('.price').textContent = Shopify.formatMoney(selectedVariant.price);
          totalPrices.push(selectedVariant.price * selectedOption.quantity);
          totalPricesWithDiscount.push(selectedVariant.price * selectedOption.quantity);

          selectedOption.discount_percentage = null;
          selectedOption.discounted_price = null;
          selectedOption.normal_price = selectedVariant.price;
        }
      }
      else {
        priceWrapper.querySelector('.price').textContent = `Intet valgt`;
        priceWrapper.querySelector('.price-compare').textContent = '';
        priceWrapper.querySelector('.price-compare').style.display = 'none';
      }
    });

    const totalPriceEl = this.querySelector('.bundle-builder__form-price');

    const sumOriginal = totalPrices.reduce((acc, price) => acc + price, 0);
    const sumFinal = totalPricesWithDiscount.reduce((acc, price) => acc + price, 0);

    if (sumOriginal > sumFinal) {
      totalPriceEl.querySelector('.price').textContent = Shopify.formatMoney(sumFinal);
      totalPriceEl.querySelector('.price-compare').textContent = Shopify.formatMoney(sumOriginal);
      totalPriceEl.querySelector('.price-compare').style.display = 'block';

      this.discount = {
        discountAmount: (sumOriginal - sumFinal) / 100,
        minimumOrderAmount: (sumOriginal) / 100
      }
    }
    else {
      totalPriceEl.querySelector('.price').textContent = Shopify.formatMoney(sumFinal);
      totalPriceEl.querySelector('.price-compare').textContent = '';
      totalPriceEl.querySelector('.price-compare').style.display = 'none';

      this.discount = null;
    }
  }

  setSelectedOption(optionIndex, optionType, optionValue) {
    if (!this.selected[optionIndex]) {
      this.selected[optionIndex] = {};
    }

    this.selected[optionIndex][optionType] = optionValue;

    this.handleUpdate(optionIndex);
  }

  handleColorSwatchClick(evt) {
    const categoryEl = evt.currentTarget.closest(".bundle-builder__form-category");

    if (!categoryEl) {
      return;
    }

    const optionIndex = categoryEl.getAttribute("data-option-index");
    const selectedColor = evt.currentTarget.getAttribute("data-color");

    document.querySelectorAll(".swatch-color.selected").forEach((swatch) => {
      swatch.classList.remove("selected");
    });

    evt.currentTarget.classList.add("selected");

    this.setSelectedOption(optionIndex, "color", selectedColor);
  }

  handleSizeOptionClick(evt) {
    const categoryEl = evt.currentTarget.closest(".bundle-builder__form-category");

    if (!categoryEl) {
      return;
    }

    const optionIndex = categoryEl.getAttribute("data-option-index");
    const selectedSize = evt.currentTarget.getAttribute("data-size");
    const parentProductSizeElement = evt.currentTarget.closest(".bundle-builder__product-size");

    const toggleButton = parentProductSizeElement.querySelector(".select-popout__toggle");
    const toggleTextSpan = toggleButton.querySelector("[data-popout-toggle-text]");

    toggleTextSpan.textContent = `${selectedSize}`;

    this.setSelectedOption(optionIndex, "size", selectedSize);
  }

  handleCartButtonClick(evt) {
    evt.preventDefault();
    const target = evt.currentTarget;

    const data = {
      items: [],
    };

    // Generate unique ID
    const uniqueId = Math.random().toString(36).substr(2, 9);

    Object.keys(this.selected).forEach((key) => {
      const option = this.selected[key];
      if (option.variant) {
        const item = {
          id: option.variant.id,
          quantity: Number(option.quantity),
          properties: {
            "Type": "Mix & Match",
            "_source": "bundle-builder",
            "_attribution": uniqueId
          }
        };

        if (option.discount_percentage) {
          item.properties._discount_details = `NOW:${option.discounted_price}|WAS:${option.normal_price}`;
        }

        data.items.push(item);
      }
    });

    if (data.items.length == 0) {
      return;
    }

    // Change the order of the items
    data.items.unshift(data.items.pop());

    data.items[data.items.length - 1].properties["_first_item"] = true;

    if (this.discount) {
      fetch("https://dawndesigns-backend-5wtyka2oka-ew.a.run.app/api/discounts/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          discountAmount: this.discount.discountAmount,
          minimumOrderAmount: this.discount.minimumOrderAmount
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          console.log(response)

          // Add the response.discountCode to a property of the first item
          data.items[data.items.length - 1].properties["_discount_code"] = response.discountCode;
          this.addToCart(data, target);
        });
    }
    else {
      this.addToCart(data, target);
    }
  }

  addToCart(data, target) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        const content = response.json();

        target.dispatchEvent(
          new CustomEvent("theme:product:add", {
            detail: {
              response: response,
              button: target,
              refreshCart: true,
            },
            bubbles: true,
          })
        );

        checkPreorder();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleQuantityMinusClick(evt) {
    const target = evt.currentTarget;
    const input = target.parentElement.querySelector(".quantity__value");
    const value = Number(input.innerText);
    const categoryEl = target.closest(".bundle-builder__form-category");
    const optionIndex = categoryEl.getAttribute("data-option-index");
    const optionConfig = this.selectedOptions[optionIndex];

    if (value == 1 || value == 0) {
      if (this.selected[optionIndex].available_types.length > 1) {
        this.selected[optionIndex].type = null;
      }

      this.selected[optionIndex].size = null;
      this.selected[optionIndex].color = null;
      this.selected[optionIndex].variant = null;
      this.selected[optionIndex].quantity = optionConfig.default_quantity || 1;
    }

    if (value - 1 > 0) {
      this.selected[optionIndex].quantity = value - 1;
    }

    this.handleUpdate(optionIndex);
  }

  handleQuantityPlusClick(evt) {
    const target = evt.currentTarget;
    const categoryEl = target.closest(".bundle-builder__form-category");
    const optionIndex = categoryEl.getAttribute("data-option-index");

    const input = target.parentElement.querySelector(".quantity__value");
    const value = Number(input.innerText);
    this.selected[optionIndex].quantity = value + 1;
    this.handleUpdate(optionIndex);
  }

  bundleBuilderTabs() {
    const categories = [...document.querySelectorAll(".bundle-builder__form-category")].slice(
      0,
      -1
    );
    const tabsContainer = document.querySelector(".bundle-builder-preview__tabs");

    const tabButtonsContainer = document.createElement("div");
    tabButtonsContainer.className = "tab-buttons";
    tabsContainer.appendChild(tabButtonsContainer);

    const svgHTML = `<span style="display: none;" class="tab-checkmark">
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.21207 7.16485L6.68047 9.95528L8.61226 6.95017L10.5441 3.94507" stroke="#646362"/>
    <circle cx="7.37808" cy="6.95062" r="6.65326" stroke="#A2A2A1" stroke-width="0.5"/>
    </svg></span>
    `;

    categories.forEach((category, index) => {
      category.style.display = "none";
      const tabButton = document.createElement("div");
      tabButton.className = "tab-button";
      tabButton.setAttribute("data-index", index);
      tabButton.textContent = category.querySelector(".category-heading").textContent;
      tabButton.innerHTML += svgHTML;
      tabButtonsContainer.appendChild(tabButton);
    });

    categories[0].style.display = "flex";
    const tabButtons = tabButtonsContainer.querySelectorAll(".tab-button");
    tabButtons[0].classList.add("active");

    tabButtons.forEach((tabButton) => {
      tabButton.addEventListener("click", (evt) => {
        const index = evt.currentTarget.getAttribute("data-index");

        tabButtonsContainer.querySelectorAll(".tab-button").forEach((tabButton) => {
          tabButton.classList.remove("active");
        });

        tabButton.classList.add("active");

        categories.forEach((category) => {
          category.style.display = "none";
        });

        categories[index].style.display = "flex";
      });
    });

    this.setHeight();
  }

  setHeight() {
    const calculatedHeight =
      window.innerHeight -
      document.querySelector(".bundle-builder__form-categories").getBoundingClientRect().top;
    document.querySelector(
      ".bundle-builder__form-categories"
    ).style.height = `${calculatedHeight}px`;
  }

  togglePopup(index) {
    const overlayContainer = document.querySelector(`.bundle-builder__form-category[data-option-index="${index}"] #overlay-container[data-name="mixMatch"]`);
    const popup = document.querySelector(`.bundle-builder__form-category[data-option-index="${index}"] #overlay-container[data-name="mixMatch"] .popup`);

    if (overlayContainer && popup) {
      if (overlayContainer.classList.contains('open')) {
        overlayContainer.classList.remove('open');
        popup.classList.remove('open');
      } else {
        overlayContainer.classList.add('open');
        popup.classList.add('open');
      }
    }
  }

  toggleOverview() {
    const overlayContainer = document.querySelector('#overlay-container[data-name="overview"]');
    const popup = document.querySelector('#overlay-container[data-name="overview"] .popup');
    if (overlayContainer && popup) {
      if (overlayContainer.classList.contains('open')) {
        overlayContainer.classList.remove('open');
        popup.classList.remove('open');
      } else {
        overlayContainer.classList.add('open');
        popup.classList.add('open');
      }
    }
  }

  productPopup() {
    this.productPopupButton = document.querySelectorAll(`[${selectors$7.productPopupButton}]`);
    this.productPopupButton.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const modal = document.querySelector(
          `#${button.getAttribute(selectors$7.productPopupButton)}`
        );

        const modalScrollContainer = modal.querySelector(selectors$7.modalScrollContainer);

        if (window.getComputedStyle(modal).display !== "none") {
          this.fadeOut(modal);
          this.formWrapper.classList.remove(classes$4.hasPopup);
          this.accessibility.removeTrapFocus();

          if (this.unlockTimer) {
            clearTimeout(this.unlockTimer);
          }
          // delay scroll unlock to prevent content shifting
          this.unlockTimer = setTimeout(() => {
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
          }, 300);
        }

        if (window.getComputedStyle(modal).display === "none") {
          this.fadeIn(modal);
          this.formWrapper.classList.add(classes$4.hasPopup);
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: true, detail: modalScrollContainer })
          );
          this.accessibility.trapFocus(modal);
        }
      });
    });
  }

  fadeIn(el, display, callback = null) {
    el.style.opacity = 0;
    el.style.display = display || 'block';
    let flag = true;

    (function fade() {
      let val = parseFloat(el.style.opacity);
      if (!((val += 0.1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      }

      if (parseInt(val) === 1 && flag && typeof callback === 'function') {
        flag = false;
        callback();
      }
    })();
  };

  fadeOut(el, callback = null) {
    el.style.opacity = 1;

    (function fade() {
      if ((el.style.opacity -= 0.1) < 0) {
        el.style.display = 'none';
      } else {
        requestAnimationFrame(fade);
      }

      if (parseFloat(el.style.opacity) === 0 && typeof callback === 'function') {
        callback();
      }
    })();
  };

  registerEventListeners() {
    this.querySelector(".product__submit__add").addEventListener("click", (evt) =>
      this.handleCartButtonClick(evt)
    );

    this.querySelectorAll(".quantity-selector .quantity__minus").forEach((button) => {
      button.addEventListener("click", (evt) => this.handleQuantityMinusClick(evt));
    });

    this.querySelectorAll(".quantity-selector .quantity__plus").forEach((button) => {
      button.addEventListener("click", (evt) => this.handleQuantityPlusClick(evt));
    });

    const mixMatchElements = [...this.querySelectorAll('.bundle-builder__mobile-mixMatch')];
    const overviewElement = this.querySelector('.bundle-builder__overview');
    const overviewOverlayContainer = document.querySelector('#overlay-container[data-name="overview"]');

    if (mixMatchElements) {
      mixMatchElements.forEach((element, i) => {
        element.addEventListener('click', () => this.togglePopup(i));
      });
    }

    if(overviewElement) {
      overviewElement.addEventListener('click', () => this.toggleOverview());
    }

    if(overviewOverlayContainer) {
      overviewOverlayContainer.addEventListener('click', () => this.toggleOverview());
    }

    const resetButton = document.getElementById('reset-button');
     if (resetButton) {
       resetButton.addEventListener('click', this.handleResetClick.bind(this));
    }
    const shareButton = document.getElementById('share-button');
     if (shareButton) {
       shareButton.addEventListener('click', this.handleShareClick.bind(this));
    }
  }

  initDefaultSelection() {
    const whiteSwatch = document.querySelector('.swatch-color[data-color="#ffffff"]');
    if (whiteSwatch) {
      this.handleColorSwatchClick({ currentTarget: whiteSwatch });
    }
  }

  initElement() {
    sections$n["bundle-builder"] = [];

    let popouts = this.querySelectorAll(selectors$I.popoutWrapper);
    popouts.forEach((wrapper) => {
      sections$n["bundle-builder"].push(new Popout(wrapper));
    });

    let quantitySelectors = this.querySelectorAll(".product-quantity-wrapper");
    quantitySelectors.forEach((wrapper) => {
      const counter = new QuantityCounter(wrapper);
      counter.init();
    });

    this.productPopup();
  }
}

customElements.define("bundle-builder", BundleBuilder);

async function loadAllProducts() {
  const templateSuffix = "json-bb";
  const collectionHandle = "all";
  const urlPrefix = window.theme.routes.root;

  if (urlPrefix !== "/") urlPrefix += "/";

  const response = await fetch(
    `${urlPrefix}collections/${collectionHandle}?view=${templateSuffix}`,
    {
      type: "GET",
    }
  );

  const json = await response.json();
  window.ALL_PRODUCTS = json.products;
}

function checkPreorder() {
  const preorderInfoDrawer = document.querySelector(".cart__foot .preorder-info");
  const preorderInfoCartPage = document.querySelector("div.cart__aside > div.preorder-info");

  preorderInfoDrawer?.classList.add("hidden");
  preorderInfoCartPage?.classList.add("hidden");
 
  const cartItems = document.querySelectorAll(".cart__item");
  if (cartItems.length === 0) return;

  let preorderShippingDate = "";
  cartItems.forEach(function(item) {
    if (item.hasAttribute("data-preorder-item")) {
      preorderInfoDrawer?.classList.remove("hidden");
      preorderInfoCartPage?.classList.remove("hidden");
      itemShippingDate = item.getAttribute("data-preorder-shipping-date");
      if (preorderShippingDate == "" || itemShippingDate > preorderShippingDate) {
        preorderShippingDate = itemShippingDate;
      }
    }
  });

  if (preorderShippingDate != "") {
    const date = new Date(preorderShippingDate);
    options = { day: '2-digit', month: '2-digit', year: 'numeric'}
    const formattedDate = date.toLocaleDateString('da-DK', options);
    document.querySelector(".cart__foot .preorder-shipping-date").innerHTML = formattedDate;
  }
}

const classes$4 = {
  expanded: 'is-expanded',
  visible: 'is-visible',
  loading: 'is-loading',
  added: 'is-added',
  siteFooterPush: 'site-footer--push',
  hasPopup: 'has-popup',
};

/* Quantity */
const selectors$T = {
  quantityHolder: "[data-quantity-holder]",
  quantityField: "[data-quantity-field]",
  quantityButton: "[data-quantity-button]",
  quantityMinusButton: "[data-quantity-minus]",
  quantityPlusButton: "[data-quantity-plus]",
  quantityReadOnly: "read-only",
  isDisabled: "is-disabled",
};

class QuantityCounter {
  constructor(holder, inCart = false) {
    this.holder = holder;
    this.quantityUpdateCart = inCart;
  }

  init() {
    // Settings
    this.settings = selectors$T;

    // DOM Elements
    this.quantity = this.holder.querySelector(this.settings.quantityHolder);

    if (!this.quantity) {
      return;
    }

    this.field = this.quantity.querySelector(this.settings.quantityField);
    this.buttons = this.quantity.querySelectorAll(this.settings.quantityButton);
    this.increaseButton = this.quantity.querySelector(this.settings.quantityPlusButton);

    // Set value or classes
    this.quantityValue = Number(this.field.value || 0);
    this.cartItemID = this.field.getAttribute("data-id");
    this.maxValue =
      Number(this.field.getAttribute("max")) > 0 ? Number(this.field.getAttribute("max")) : null;
    this.minValue =
      Number(this.field.getAttribute("min")) > 0 ? Number(this.field.getAttribute("min")) : 0;
    this.disableIncrease = this.disableIncrease.bind(this);

    // Flags
    this.emptyField = false;

    // Methods
    this.updateQuantity = this.updateQuantity.bind(this);
    this.decrease = this.decrease.bind(this);
    this.increase = this.increase.bind(this);

    this.disableIncrease();

    // Events
    if (!this.quantity.classList.contains(this.settings.quantityReadOnly)) {
      this.changeValueOnClick();
      this.changeValueOnInput();
    }
  }

  /**
   * Change field value when click on quantity buttons
   *
   * @return  {Void}
   */

  changeValueOnClick() {
    const that = this;

    this.buttons.forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();
        const clickedElement = event.target;
        const isDescrease =
          clickedElement.matches(that.settings.quantityMinusButton) ||
          clickedElement.closest(that.settings.quantityMinusButton);
        const isIncrease =
          clickedElement.matches(that.settings.quantityPlusButton) ||
          clickedElement.closest(that.settings.quantityPlusButton);

        if (isDescrease) {
          that.decrease();
        }

        if (isIncrease) {
          that.increase();
        }

        that.updateQuantity();
      });
    });
  }

  /**
   * Change field value when input new value in a field
   *
   * @return  {Void}
   */

  changeValueOnInput() {
    this.field.addEventListener("change", () => {
      this.quantityValue = this.field.value;

      if (this.field.value === "") {
        this.emptyField = true;
      }

      this.updateQuantity();
    });
  }

  /**
   * Update field value
   *
   * @return  {Void}
   */

  updateQuantity() {
    if (this.maxValue < this.quantityValue && this.maxValue !== null) {
      this.quantityValue = this.maxValue;
    }

    if (this.minValue > this.quantityValue) {
      this.quantityValue = this.minValue;
    }

    this.field.value = this.quantityValue;

    this.disableIncrease();

    if (this.quantityUpdateCart) {
      this.updateCart();
    }
  }

  /**
   * Decrease value
   *
   * @return  {Void}
   */

  decrease() {
    if (this.quantityValue > this.minValue) {
      this.quantityValue--;

      return;
    }

    this.quantityValue = 0;
  }

  /**
   * Increase value
   *
   * @return  {Void}
   */

  increase() {
    this.quantityValue++;
  }

  /**
   * Disable increase
   *
   * @return  {[type]}  [return description]
   */

  disableIncrease() {
    this.increaseButton.classList.toggle(
      this.settings.isDisabled,
      this.quantityValue >= this.maxValue && this.maxValue !== null
    );
  }

  /**
   * Update cart
   *
   * @return  {Void}
   */

  updateCart() {
    const event = new CustomEvent("theme:cart:update", {
      bubbles: true,
      detail: {
        id: this.cartItemID,
        quantity: this.quantityValue,
        valueIsEmpty: this.emptyField,
      },
    });

    this.holder.dispatchEvent(event);
  }
}

/* POPOUT */

const selectors$I = {
  popoutWrapper: "[data-popout]",
  popoutList: "[data-popout-list]",
  popoutToggle: "[data-popout-toggle]",
  popoutToggleText: "[data-popout-toggle-text]",
  popoutInput: "[data-popout-input]",
  popoutOptions: "[data-popout-option]",
  popoutPrevent: "data-popout-prevent",
  popoutQuantity: "data-quantity-field",
  dataValue: "data-value",
  ariaExpanded: "aria-expanded",
  ariaCurrent: "aria-current",
  productGridImage: "[data-product-image]",
  productGrid: "[data-product-grid-item]",
};

const classes$z = {
  listVisible: "popout-list--visible",
  visible: "is-visible",
  active: "is-active",
};

let sections$n = {};

class Popout {
  constructor(popout) {
    this.container = popout;
    this.popoutList = this.container.querySelector(selectors$I.popoutList);
    this.popoutToggle = this.container.querySelector(selectors$I.popoutToggle);
    this.popoutToggleText = this.container.querySelector(selectors$I.popoutToggleText);
    this.popoutInput = this.container.querySelector(selectors$I.popoutInput);
    this.popoutOptions = this.container.querySelectorAll(selectors$I.popoutOptions);
    this.productGrid = this.popoutList.closest(selectors$I.productGrid);
    this.popoutPrevent = this.container.getAttribute(selectors$I.popoutPrevent) === "true";
    // this.popupToggleFocusoutEvent = (evt) => this.popupToggleFocusout(evt);
    this.popupListFocusoutEvent = (evt) => this.popupListFocusout(evt);
    this.popupToggleClickEvent = (evt) => this.popupToggleClick(evt);
    this.containerKeyupEvent = (evt) => this.containerKeyup(evt);
    this.bodyClickEvent = (evt) => this.bodyClick(evt);

    this._connectOptions();
    this._connectToggle();
    this._onFocusOut();
    this.popupListMaxWidth();
  }

  popupToggleClick(evt) {
    const ariaExpanded = evt.currentTarget.getAttribute(selectors$I.ariaExpanded) === "true";

    if (this.productGrid) {
      const productGridItemImage = this.productGrid.querySelector(selectors$I.productGridImage);

      if (productGridItemImage) {
        productGridItemImage.classList.toggle(classes$z.visible, !ariaExpanded);
      }

      this.popoutList.style.maxHeight = `${Math.abs(
        this.popoutToggle.getBoundingClientRect().bottom -
          this.productGrid.getBoundingClientRect().bottom
      )}px`;
    }

    evt.currentTarget.setAttribute(selectors$I.ariaExpanded, !ariaExpanded);
    this.popoutList.classList.toggle(classes$z.listVisible);
    this.popupListMaxWidth();
  }

  popupToggleFocusout(evt) {
    const popoutLostFocus = this.container.contains(evt.relatedTarget);

    if (!popoutLostFocus) {
      this._hideList();
    }
  }

  popupListFocusout(evt) {
    const childInFocus = evt.currentTarget.contains(evt.relatedTarget);
    const isVisible = this.popoutList.classList.contains(classes$z.listVisible);

    if (isVisible && !childInFocus) {
      this._hideList();
    }
  }

  popupListMaxWidth() {
    this.popoutList.style.maxWidth = `${parseInt(
      document.body.clientWidth - this.popoutList.getBoundingClientRect().left
    )}px`;
  }

  popupOptionsClick(evt) {
    const link = evt.target.closest(selectors$I.popoutOptions);
    if (link.attributes.href.value === "#") {
      evt.preventDefault();

      let attrValue = "";

      if (evt.currentTarget.getAttribute(selectors$I.dataValue)) {
        attrValue = evt.currentTarget.getAttribute(selectors$I.dataValue);
      }

      this.popoutInput.value = attrValue;

      if (this.popoutPrevent) {
        const currentTarget = evt.currentTarget.parentElement;
        const listTargetElement = this.popoutList.querySelector(`.${classes$z.active}`);
        const targetAttribute = this.popoutList.querySelector(`[${selectors$I.ariaCurrent}]`);

        this.popoutInput.dispatchEvent(new Event("change"));

        if (listTargetElement) {
          listTargetElement.classList.remove(classes$z.active);
          currentTarget.classList.add(classes$z.active);
        }

        if (
          this.popoutInput.hasAttribute(selectors$I.popoutQuantity) &&
          !currentTarget.nextSibling
        ) {
          this.container.classList.add(classes$z.active);
        }

        if (targetAttribute && targetAttribute.hasAttribute(`${selectors$I.ariaCurrent}`)) {
          targetAttribute.removeAttribute(`${selectors$I.ariaCurrent}`);
          evt.currentTarget.setAttribute(`${selectors$I.ariaCurrent}`, "true");
        }

        if (attrValue !== "") {
          this.popoutToggleText.textContent = attrValue;
        }

        // this.popupToggleFocusout(evt);
        this.popupListFocusout(evt);
      } else {
        this._submitForm(attrValue);
      }
    }
  }

  containerKeyup(evt) {
    if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
      return;
    }
    this._hideList();
    this.popoutToggle.focus();
  }

  bodyClick(evt) {
    const isOption = this.container.contains(evt.target);
    const isVisible = this.popoutList.classList.contains(classes$z.listVisible);

    if (isVisible && !isOption) {
      this._hideList();
    }
  }

  unload() {
    document.body.removeEventListener("click", this.bodyClickEvent);
  }

  _connectToggle() {
    this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
  }

  _connectOptions() {
    if (this.popoutOptions.length) {
      this.popoutOptions.forEach((element) => {
        element.addEventListener("click", (evt) => this.popupOptionsClick(evt));
      });
    }
  }

  _onFocusOut() {
    // this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent);

    this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent);

    this.container.addEventListener("keyup", this.containerKeyupEvent);

    document.body.addEventListener("click", this.bodyClickEvent);
  }

  _submitForm() {
    const form = this.container.closest("form");
    if (form) {
      form.submit();
    }
  }

  _hideList() {
    this.popoutList.classList.remove(classes$z.listVisible);
    this.popoutToggle.setAttribute(selectors$I.ariaExpanded, false);
  }
}

const selectors$7 = {
  addToCart: "[data-add-to-cart]",
  priceWrapper: "[data-price-wrapper]",
  productImage: "[data-product-image]",
  productJson: "[data-product-json]",
  form: "[data-product-form]",
  thumbs: "[data-product-thumbs]",
  dataSectionId: "data-section-id",
  dataCartBar: "data-cart-bar",
  dataProductShare: "[data-product-share]",
  dataProductShareValue: "data-product-share",
  dataProductShareTitleValue: "data-product-share-title",
  cartBar: "#cart-bar",
  cartBarAdd: "data-add-to-cart-bar",
  cartBarScroll: "data-cart-bar-scroll",
  productSubmitAdd: ".product__submit__add",
  templateProduct: "#template-product",
  siteFooterWrapper: ".site-footer-wrapper",
  toggleTruncateHolder: "[data-truncated-holder]",
  toggleTruncateButton: "[data-truncated-button]",
  toggleTruncateContent: "[data-truncated-content]",
  toggleTruncateContentAttr: "data-truncated-content",
  quickAddButton: "[data-quick-add-btn]",
  quickAddButtonText: "[data-quick-add-btn-text]",
  upsellButton: "[data-upsell-btn]",
  productPopupButton: "data-product-popup",
  modalScrollContainer: "[data-tabs-holder]",
  formWrapper: "[data-form-wrapper]",
  formHolder: "[data-product-form]",
  formButton: "[data-add-to-cart]",
  slider: "[data-slider]",
  sliderIndex: "data-slider-index",
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount}} DKK";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ".");
    decimal = defaultOption(decimal, ",");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
